<template>
  <div class="hotrecommend clearfix">
    <el-carousel :interval="6000" arrow="always" indicator-position="outside" v-if="isPC&&recommendItems.length>0">
      <el-carousel-item :key="index" v-for="(item,index) in recommendItems" v-if="index%5 == 0">
        <slot v-if="index<recommendItems.length&&index%5==0">
          <div class="hritem"><router-link :to="{path:'/recommend?id='+recommendItems[index].pkId}"><img v-lazy="recommendItems[index].path" /><span class="hrtitle">{{recommendItems[index].name}}</span></router-link></div>
          <div class="hritem" v-if="index+1<recommendItems.length"><router-link :to="{path:'/recommend?id='+recommendItems[index+1].pkId}"><img v-lazy="recommendItems[index+1].path +'&type=1&size=240x320'" /><span class="hrtitle">{{recommendItems[index+1].name}}</span></router-link></div>
          <div class="hritem" v-if="index+2<recommendItems.length"><router-link :to="{path:'/recommend?id='+recommendItems[index+2].pkId}"><img v-lazy="recommendItems[index+2].path +'&type=1&size=240x320'" /><span class="hrtitle">{{recommendItems[index+2].name}}</span></router-link></div>
          <div class="hritem" v-if="index+3<recommendItems.length"><router-link :to="{path:'/recommend?id='+recommendItems[index+3].pkId}"><img v-lazy="recommendItems[index+3].path +'&type=1&size=240x320'" /><span class="hrtitle">{{recommendItems[index+3].name}}</span></router-link></div>
          <div class="hritem" v-if="index+4<recommendItems.length"><router-link :to="{path:'/recommend?id='+recommendItems[index+4].pkId}"><img v-lazy="recommendItems[index+4].path +'&type=1&size=240x320'" /><span class="hrtitle">{{recommendItems[index+4].name}}</span></router-link></div>
        </slot>
      </el-carousel-item>
    </el-carousel>
    <ul v-if="!isPC" class="clearfix" :style="'width:'+recommendItems.length*130+'px'">
      <li :key="index" v-for="(item,index) in recommendItems">
        <!--多楼盘样式 -->
        <slot v-if="item.type==1">
          <router-link :to="{path:'recommend?id='+item.pkId+'&t='+item.hotStyle}"><img v-lazy="item.path +'&type=1&size=240x320'" /><span class="hrtitle">{{item.name}}</span></router-link>
        </slot>
        <!-- 单楼盘样式1 -->
        <slot v-if="item.type==2&&item.hotStyle==1">
          <router-link :to="{path:'recommendSingle?id='+item.pkId}"><img v-lazy="item.path +'&type=1&size=240x320'" /><span class="hrtitle">{{item.name}}</span></router-link>
        </slot>
        <!-- 单楼盘样式2 -->
        <slot v-if="item.type==2&&item.hotStyle==2">
          <router-link :to="{path:'recommendSingle1?id='+item.pkId}"><img v-lazy="item.path +'&type=1&size=240x320'" /><span class="hrtitle">{{item.name}}</span></router-link>
        </slot>
      </li>
    </ul>
    <div class="noitem" v-if="recommendItems.length==0"><span>{{msg}}</span></div>
  </div>
</template>

<script>
export default {
  name: 'PCFilter',
  props:{
    isPC:Boolean
  },
  data () {
    return {
      recommendItems:[],
      msg:'正在加载...'
    }
  },
  mounted(){
    var _this = this;
    _this.getHot();
  },
  methods:{
    getHot:function(){
      this.$http.get('/api/baidu/getHotThemeList').then((response)=>{
        this.recommendItems = response.data.result;
        this.msg='暂无数据'
      }).catch((response)=>{
        console.log(response)
      })
    },
  }
}
</script>

<style scoped>
.hotrecommend{overflow:auto;-webkit-overflow-scrolling:touch;}
.hritem{width:18.72%;float:left;padding-bottom:5px;border-radius:3px;overflow:hidden;border:1px solid #EBEEF5;box-sizing:border-box;}
.hritem+.hritem{margin-left:1.6%;}
.hritem:hover{box-shadow:0 2px 12px 0 rgba(0,0,0,.1);}
.hritem img{width:100%;height:160px;}
.hrtitle{line-height:30px;text-align:center;display:block;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.hrtitle:hover{text-decoration:underline;}

@media (min-width:769px){
  .hotrecommend{padding-top:25px;margin-bottom:-15px;}
  .hritem img{object-position:top center;}
  .hotrecommend >>> .el-carousel .el-carousel__container{height:197px;}
}
/*@media (min-width:900px){
  .hritem img{height:130px;}
  .hotrecommend >>> .el-carousel .el-carousel__container{height:167px;}
}
@media (min-width:1000px){
  .hritem img{height:160px;}
  .hotrecommend >>> .el-carousel .el-carousel__container{height:197px;}
}*/
@media (max-width:768px){
  .hotrecommend{padding-top:15px;padding-bottom:15px;}
  .hotrecommend ul{height:188px;overflow:hidden;padding-right:5px;}
  .hotrecommend li{float:left;width:120px;margin-right:10px;}
  .hotrecommend li img{width:100%;height:160px;border-radius:4px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);}
  .hotrecommend li .hrtitle{line-height:22px;margin-top:6px;}
}

</style>



// WEBPACK FOOTER //
// src/components/public/HotRecom.vue